import React from 'react';

import Permissions from '@/common/permissions';
import ActivityLog from '@/modules/ActivityLog';
import { useHasAccess } from '@/modules/core';
import ModuleWrapper from '@/modules/plan/ModuleWrapper';

const RoleSetupActivityLog: React.FC = () => {
  const hasActivityLog = useHasAccess([
    {
      permission: Permissions.VIEW_ROLES_AND_SECURITY
    },
    {
      permission: Permissions.EDIT_ROLES_AND_SECURITY
    }
  ]);
  if (!hasActivityLog) return;

  return (
    <ModuleWrapper
      testId="activity_log"
      anchorId="activity_log"
      title="Activity Log"
      expandless
      defaultExpandedValue={false}
    >
      <ActivityLog />
    </ModuleWrapper>
  );
};

export default React.memo(RoleSetupActivityLog);